import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import * as React from "react";
import AddTasks from "./AddTasks";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function TaskModal({
  open,
  handleClose,
  modalData,
  module,
  editingData,
  isEditing,
  refetchTaskDetails,
  contextContent = null,
  title,
  taskType,
  admissionId,
  moduleEntryType,
  moduleEntryId,
  termIndex,
  termDataSnapshot,
  paymentUuid,
}) {
  return (
    <React.Fragment>
      <BootstrapDialog
        // onClose={handleClose}
        open={open}
        maxWidth={"md"}
        fullWidth
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {title ?? (isEditing ? "Edit task" : "Assign task")}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        {contextContent}
        <DialogContent dividers>
          <AddTasks
            modal={true}
            modalData={modalData}
            module={module}
            handleClose={handleClose}
            isEditing={isEditing}
            editingData={editingData}
            refetchTaskDetails={refetchTaskDetails}
            taskType={taskType}
            admissionId={admissionId}
            moduleEntryType={moduleEntryType}
            moduleEntryId={moduleEntryId}
            termIndex={termIndex}
            paymentUuid={paymentUuid}
            termDataSnapshot={termDataSnapshot}
          />
        </DialogContent>
      </BootstrapDialog>
    </React.Fragment>
  );
}
